import { BehaviorSubject, Observable, of } from 'rxjs';
import { Model } from '../../../shared/models/model.class';
import { switchMap } from 'rxjs/operators';
import { ApiHttpClient } from 'app/http/clients/api';
import { Contact } from 'app/models/dto/contact.model';
import { LenderUser } from 'app/models/dto/lender-user.model';

export class Borrower extends Model<Borrower> {

    id: number;
    assignedLenderName: string;
    assignedLenderId: number;
    clientId: number;
    creditPullStale: boolean;
    fd_action_needed;
    applicationSignedRecently: boolean;
    fd_action_taken;
    fd_contract_received;
    fd_contract_requested;
    fd_process_started;
    lenderUser: BehaviorSubject<LenderUser | null> | null;
    createdTimestamp: number;
    modified: Date;
    modifiedTimestamp: number;
    name: string;
    online: boolean;
    phoneCountryCodeId: number;
    phone: string;
    phoneWrong: boolean;
    primary_contact: Contact;
    returned: boolean;
    shared_with_lendio: any[];
    sharedWith: number[];
    source: string;
    leadSource: string;
    status: string;
    stage: string;
    last_inactive_status: null | {
      reason: string;
    };
    taskIds: number[];
    timezone: string;
    userId: number;
    workflowAssignments: any[];
    documents?: any;
    isPPPLead: boolean;
    isPPPSecondDrawLead: boolean;
    is_sba_active_application: boolean;
    submitForPLP?: boolean;
    lastFundedDeal?: {
      id: number;
      borrowerId: number;
      status: string;
      loanProductId: number;
      type: string;
      loanProductLenderId: number;
      acceptedOfferId: number;
      closedBy: number;
      dateClosed: string;
      termCompletePercentage: number;
      calculatedTermCompletePercentage?: number;
      percentPaid: null | number | string;
      term: number;
      amount: string | number;
      institutionName: string;
      dateClosedTimestamp: number;
    };

    private _claimable: BehaviorSubject<boolean> | null = null;

    constructor(
        private http: ApiHttpClient,
        props: any = {}
    ) {
        super(props);

        // Set default values if not already set
        const current = Object.assign({}, this);
        const defaults = {
            lenderUser: null,
            online: false,
            workflowAssignments: [],
            shared_with_lendio: []
        };
        Object.assign(this, defaults, current);
    }

    get claimable(): Observable<boolean> {
        if (this._claimable === null) {
            this._claimable = this.loadClaimable();
        }
        return this._claimable;
    }
    setClaimable(claimable: boolean) {
        if (this._claimable !== null) {
            this._claimable.next(claimable);
        }
    }

    fillable() {
        return [
            'id',
            'name',
            'phone',
            'status',
            'returned',
            'userId',
            'online',
            'phoneWrong',
            'clientId',
            'primary_contact',
            'shared_with_lendio',
            'fd_process_started',
            'fd_contract_requested',
            'fd_contract_received',
            'fd_action_needed',
            'fd_action_taken',
            'sharedWith',
            'source',
            'timezone',
            'workflowAssignments',
        ];
    }

    serializeable() {
        return this.fillable();
    }

    assignToUserId(userId: number) {
        return this.http.put(`/borrower/${this.id}`, {
                id: this.id,
                assignedLenderId: userId
            }).pipe(
                switchMap(() => {
                    this.userId = userId;
                    this.loadClaimable();
                    return of(true);
                })
            );
    }

    updateBorrowerProfile(attrs) {
        return this.http.put(`/borrower-profile/${this.id}`, attrs || {});
    }

    private loadClaimable() {
        if (this._claimable === null) {
            this._claimable = new BehaviorSubject(false);
        }
        this.http.get<boolean>(`/borrower/${this.id}/claimable`).subscribe((claimable) => {
            if (this._claimable !== null) {
                this._claimable.next(claimable);
            }
        });
        return this._claimable;
    }

}
